<template>
  <v-container>
    <h1>Edit Task {{ uniqueId }}</h1>
    <v-tabs v-model="activeTab" background-color="primary" dark>
      <v-tab v-for="(doc, docType, index) in data">{{ docType }}</v-tab>
    </v-tabs>
    <v-tabs-items v-model="activeTab">
      <v-tab-item v-for="(doc, docType, index) in data">
        <v-card flat>
          <v-card-text>
            <v-json-editor
              v-model="data[docType]"
              height="400"
              :expanded="true"
              @input="updateData(value, docType)"
            />
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
    <v-card-actions>
      <v-btn
        color="secondary"
        @click="goBack"
        :disabled="loading"
      >
        Back
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        @click="submitChanges"
        :loading="loading"
        :disabled="loading"
      >
        Confirm
      </v-btn>
    </v-card-actions>
  </v-container>
</template>

<script>
import axios from 'axios'
import VJsonEditor from 'v-jsoneditor'

export default {
  name: 'EditTask',
  components: {
    VJsonEditor
  },
  data() {
    return {
      taskId: this.$route.params.id,
      uniqueId: this.$route.params.uniqueId,
      activeTab: 0,
      data: {},
      loading: false,
      editorOptions: {
        // mode: 'code'
      }
    }
  },
  methods: {
    async fetchTaskData() {
      this.loading = true
      try {
        const response = await this.$http.get(`/api/tasks/${this.taskId}/extract`)
        this.data = response.data
      } catch (error) {
        console.error('Error fetching task data:', error)
        alert('Failed to load task data')
      }
      this.loading = false
    },
    updateData(value, docType) {
      this.data[docType] = value
    },
    async submitChanges() {
      this.loading = true
      try {
        const payload = this.data
        await this.$http.post(`/api/tasks/${this.taskId}/compare`, payload)
        alert('Changes saved successfully')
        this.$router.push({ path: 'tasks', query: { show_review : this.$route.query.show_review } })
      } catch (error) {
        console.error('Error saving changes:', error)
        alert('Failed to save changes')
      }
      this.loading = false
    },
    goBack() {
      this.$router.push({ path: 'tasks', query: { show_review : this.$route.query.show_review } })
    }
  },
  mounted() {
    this.fetchTaskData()
  }
}
</script>
